import script from "./BanUserDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BanUserDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BanUserDialog.vue?vue&type=style&index=0&id=619caae6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619caae6"]])

export default __exports__